/* eslint-disable react/prop-types */
/* eslint-disable no-irregular-whitespace */
/* eslint-disable react/jsx-key */
import React, { Component } from "react";
import Header from "../Components/Header";
import SubHeader from "../Components/SubHeader";
import Loader from "../Components/Loader";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import YouTubePlayer from "../Components/YoutubePlayer";
import Footer from "../Components/Footer";
import MainBanner from "../Components/MainBanner";
import { Link } from "react-router-dom";
import Cookies from "js-cookie";
import "../Styles/ana-sayfa.css";

import {
  BookOpen,
  Package,
  Calendar,
  Target,
  Zap,
  TrendingUp,
  Smile,
  Award,
  ShoppingCart,
  CheckCircle,
  Building,
} from "lucide-react";
import UniversalVideoPlayer from "../Components/YoutubePlayer";
import DarkVeilHeroBanner from "../Components/DarkVeilHeroBanner";

export default class UniversalTeamAnaSayfa extends Component {
  constructor(props) {
    super(props);
    this.state = {
      phone: "",
      showLoginModal: false,
      selectedSectionTitle: "",
      mainSections: [
        {
          id: 1,
          icon: "BookOpen",
          title: "Eğitimler",
          description:
            "Uzman eğitmenlerle kişisel gelişim ve iş başarısı için eğitimler.",
          buttonText: "Eğitimleri İncele",
          bgColor: "bg-blue-100",
          iconColor: "text-blue-600",
          path: "/egitimler",
        },
        {
          id: 2,
          icon: "Package",
          title: "Ürünler",
          description:
            "Kaliteli ürünlerimizle hem sağlığınızı koruyun hem de kazanç elde edin.",
          buttonText: "Ürünleri İncele",
          bgColor: "bg-green-100",
          iconColor: "text-green-600",
          path: "/egitimler/urun-egitimleri",
        },
        {
          id: 3,
          icon: "Building",
          title: "Ofislerimiz",
          description:
            "Motivasyon ve eğitim dolu network marketing ofislerimiz sizleri bekliyor.",
          buttonText: "Ofisleri İncele",
          bgColor: "bg-purple-100",
          iconColor: "text-purple-600",
          path: "/ofislerimiz",
        },
      ],
      philosophy: [
        {
          id: 1,
          icon: "Target",
          title: "HAYAL ET",
          description:
            "Başarmak için önce hayal etmelisin. Burası hayallerini ve kendini gerçekleştirmek isteyenlerin yeridir.",
          gradient: "from-pink-500 to-rose-500",
        },
        {
          id: 2,
          icon: "Zap",
          title: "İNAN",
          description:
            "Başaracağına en önce sen inanmalısın. Kendine ve takımına inanırsan çabuk başarıya ulaşırsın.",
          gradient: "from-blue-500 to-cyan-500",
        },
        {
          id: 3,
          icon: "TrendingUp",
          title: "BAŞLA",
          description:
            "Her hayalin bir bedeli vardır ve sadece bu bedeli ödeyenler hayallerine ulaşır. Bu işteki bedel sadece emek vermektir.",
          gradient: "from-purple-500 to-indigo-500",
        },
      ],
      events: [
        {
          id: 1,
          title: "Ürün Semineri - Premium Sağlık Ürünleri",
          date: "15 Temmuz 2025",
          time: "19:00 - 21:00",
          location: "Ankara Merkez Ofis",
          type: "Eğitim",
          image:
            "https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=400",
        },
        {
          id: 2,
          title: "Liderlik Gelişim Programı",
          date: "22 Temmuz 2025",
          time: "10:00 - 17:00",
          location: "İstanbul Kongre Merkezi",
          type: "Workshop",
          image:
            "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?w=400",
        },
        {
          id: 3,
          title: "Başarı Hikayeleri Buluşması",
          date: "30 Temmuz 2025",
          time: "18:00 - 20:00",
          location: "Online Etkinlik",
          type: "Motivasyon",
          image:
            "https://images.unsplash.com/photo-1511578314322-379afb476865?w=400",
        },
      ],
      statistics: [
        {
          number: "180000+",
          label: "Mutlu\nÜye",
          color: "#3b82f6",
          icon: "Smile",
        },
        {
          number: "100+",
          label: "Eğitim\nProgramı",
          color: "#10b981",
          icon: "Award",
        },
        {
          number: "40+",
          label: "Premium\nÜrün",
          color: "#8b5cf6",
          icon: "ShoppingCart",
        },
        {
          number: "%100",
          label: "Memnuniyet\nOranı",
          color: "#f59e0b",
          icon: "CheckCircle",
        },
      ],
    };
  }

  showLoginPopup = (sectionTitle) => {
    this.setState({
      showLoginModal: true,
      selectedSectionTitle: sectionTitle,
    });
  };

  closeLoginModal = () => {
    this.setState({
      showLoginModal: false,
      selectedSectionTitle: "",
    });
  };

  redirectToLogin = () => {
    window.location.href = "/login";
  };

  handleSectionClick = (section, e) => {
    e.preventDefault();

    const isLoggedIn = Cookies.get("token") != null;

    if (
      (section.path === "/egitimler" ||
        section.path === "/egitimler/urun-egitimleri") &&
      !isLoggedIn
    ) {
      this.showLoginPopup(section.title);
      return;
    }

    if (section.path.startsWith("/")) {
      if (this.props.history) {
        this.props.history.push(section.path);
      } else {
        window.location.href = section.path;
      }
    } else {
      window.location.href = section.path;
    }
  };

  MainSections = () => {
    const iconComponents = {
      BookOpen: BookOpen,
      Package: Package,
      Calendar: Calendar,
      Building: Building,
    };

    return (
      <>
        <div className="row">
          {this.state.mainSections.map((section) => {
            const IconComponent = iconComponents[section.icon];
            return (
              <div
                key={section.id}
                className="col-lg-4 col-md-12"
                style={{ marginBottom: "30px" }}
              >
                <div
                  className="item universal-card universal-shimmer"
                  style={{
                    background:
                      "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
                    borderRadius: "16px",
                    textAlign: "center",
                    boxShadow: "0 20px 40px rgba(0,0,0,0.09)",
                    border: "1px solid rgba(226, 232, 240, 0.5)",
                    height: "100%",
                    minHeight: "350px",
                    position: "relative",
                    overflow: "hidden",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                >
                  <div
                    className="universal-pattern"
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      background:
                        "linear-gradient(45deg, transparent 30%, rgba(255,255,255,0.1) 50%, transparent 70%)",
                      pointerEvents: "none",
                    }}
                  ></div>
                  <div style={{ position: "relative", zIndex: 1 }}>
                    <div
                      className="universal-icon"
                      style={{
                        width: "80px",
                        height: "80px",
                        background:
                          section.bgColor === "bg-blue-100"
                            ? "linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)"
                            : section.bgColor === "bg-green-100"
                              ? "linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%)"
                              : "linear-gradient(135deg, #f3e8ff 0%, #e9d5ff 100%)",
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        margin: "0 auto 25px",
                        boxShadow:
                          section.bgColor === "bg-blue-100"
                            ? "0 8px 25px rgba(37, 99, 235, 0.15)"
                            : section.bgColor === "bg-green-100"
                              ? "0 8px 25px rgba(22, 163, 74, 0.15)"
                              : "0 8px 25px rgba(147, 51, 234, 0.15)",
                      }}
                    >
                      <IconComponent
                        size={35}
                        style={{
                          color:
                            section.iconColor === "text-blue-600"
                              ? "#2563eb"
                              : section.iconColor === "text-green-600"
                                ? "#16a34a"
                                : "#9333ea",
                        }}
                      />
                    </div>
                    <h4
                      style={{
                        fontSize: "24px",
                        fontWeight: "bold",
                        marginBottom: "15px",
                        color: "#333",
                      }}
                    >
                      {section.title}
                    </h4>
                    <p
                      style={{
                        color: "#666",
                        lineHeight: "1.6",
                        marginBottom: "25px",
                      }}
                    >
                      {section.description}
                    </p>
                    <div className="main-button">
                      <button
                        onClick={(e) => this.handleSectionClick(section, e)}
                        className="universal-button"
                        style={{
                          background:
                            "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                          color: "white",
                          padding: "0",
                          borderRadius: "12px",
                          textDecoration: "none",
                          fontWeight: "600",
                          display: "inline-block",
                          width: "100%",
                          textAlign: "center",
                          lineHeight: "48px",
                          height: "48px",
                          boxShadow: "0 8px 25px rgba(102, 126, 234, 0.3)",
                          border: "none",
                          cursor: "pointer",
                        }}
                      >
                        {section.buttonText}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {this.state.showLoginModal && (
          <div
            className="login-modal-overlay"
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.7)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 9999,
            }}
            onClick={this.closeLoginModal}
          >
            <div
              className="login-modal"
              style={{
                background: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
                borderRadius: "20px",
                padding: "40px",
                maxWidth: "450px",
                width: "90%",
                textAlign: "center",
                boxShadow: "0 25px 50px rgba(0, 0, 0, 0.25)",
                position: "relative",
                border: "1px solid rgba(226, 232, 240, 0.5)",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <div
                style={{
                  width: "80px",
                  height: "80px",
                  background:
                    "linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 25px",
                  boxShadow: "0 8px 25px rgba(245, 158, 11, 0.15)",
                }}
              >
                <svg
                  width="35"
                  height="35"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#f59e0b"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                  <circle cx="12" cy="16" r="1" />
                  <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                </svg>
              </div>

              <h3
                style={{
                  fontSize: "24px",
                  fontWeight: "bold",
                  marginBottom: "15px",
                  color: "#1e293b",
                }}
              >
                Giriş Yapmanız Gerekiyor
              </h3>

              <p
                style={{
                  color: "#64748b",
                  lineHeight: "1.6",
                  marginBottom: "25px",
                  fontSize: "16px",
                }}
              >
                <strong>{this.state.selectedSectionTitle}</strong> bölümünü
                görüntülemek için lütfen önce giriş yapın.
              </p>

              <div
                style={{
                  display: "flex",
                  gap: "15px",
                  justifyContent: "center",
                }}
              >
                <button
                  className="login-btn-primary"
                  onClick={this.redirectToLogin}
                  style={{
                    background:
                      "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                    color: "white",
                    padding: "12px 30px",
                    borderRadius: "12px",
                    border: "none",
                    fontWeight: "600",
                    fontSize: "16px",
                    cursor: "pointer",
                    boxShadow: "0 8px 25px rgba(102, 126, 234, 0.3)",
                  }}
                >
                  Giriş Yap
                </button>

                <button
                  className="login-btn-secondary"
                  onClick={this.closeLoginModal}
                  style={{
                    background: "transparent",
                    color: "#64748b",
                    padding: "12px 25px",
                    borderRadius: "12px",
                    border: "2px solid #e2e8f0",
                    fontWeight: "600",
                    fontSize: "16px",
                    cursor: "pointer",
                  }}
                >
                  İptal
                </button>
              </div>
            </div>
          </div>
        )}
      </>
    );
  };

  PhilosophyCards = () => {
    const iconComponents = {
      Target: Target,
      Zap: Zap,
      TrendingUp: TrendingUp,
    };

    const getIconColor = (gradient) => {
      if (gradient === "from-pink-500 to-rose-500") return "#ec4899";
      if (gradient === "from-blue-500 to-cyan-500") return "#3b82f6";
      return "#8b5cf6";
    };

    return (
      <div className="row align-items-center">
        <div className="col-lg-6 col-md-12 mb-30">
          <div className="philosophy-list">
            {this.state.philosophy.map((item) => {
              const IconComponent = iconComponents[item.icon];
              return (
                <div
                  key={item.id}
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    marginBottom: "40px",
                    paddingBottom: "20px",
                    borderBottom:
                      item.id !== this.state.philosophy.length
                        ? "1px solid #e2e8f0"
                        : "none",
                  }}
                >
                  <div
                    className="philosophy-icon"
                    style={{
                      minWidth: "60px",
                      height: "60px",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginRight: "25px",
                      boxShadow: "0 4px 15px rgba(0,0,0,0.08)",
                      background: "white",
                      border: `2px solid ${getIconColor(item.gradient)}`,
                    }}
                  >
                    <IconComponent
                      size={30}
                      color={getIconColor(item.gradient)}
                    />
                  </div>
                  <div>
                    <h4
                      style={{
                        fontSize: "22px",
                        fontWeight: "700",
                        marginBottom: "10px",
                        color: "#1e293b",
                      }}
                    >
                      {item.title}
                    </h4>
                    <p
                      style={{
                        lineHeight: "1.7",
                        color: "#64748b",
                        fontSize: "16px",
                      }}
                    >
                      {item.description}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <div className="col-lg-6 col-md-12 mb-30">
          <div
            className="philosophy-image-container"
            style={{
              borderRadius: "16px",
              overflow: "hidden",
              boxShadow: "0 20px 50px rgba(0,0,0,0.15)",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src="/Assets/Images/ut3felsefe.avif"
              alt="Universal Team Philosophy"
              style={{
                width: "100%",
                height: "auto",
                display: "block",
                objectFit: "cover",
                minHeight: "450px",
                maxHeight: "600px",
              }}
            />
          </div>
        </div>
      </div>
    );
  };

  StatisticsSection = () => {
    const iconComponents = {
      Smile: Smile,
      Award: Award,
      ShoppingCart: ShoppingCart,
      CheckCircle: CheckCircle,
    };

    return (
      <div className="row justify-content-center">
        {this.state.statistics.map((stat, index) => {
          const IconComponent = iconComponents[stat.icon];

          return (
            <div key={index} className="col-lg-3 col-md-6 mb-30">
              <div
                className="item universal-stats-item"
                style={{
                  padding: "30px 15px",
                  textAlign: "center",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  position: "relative",
                }}
              >
                <div
                  className="stat-icon-container"
                  style={{
                    "--stat-shadow-normal": `inset 0 0 10px ${stat.color}10`,
                    "--stat-shadow-hover": `inset 0 0 15px ${stat.color}30, 0 0 20px ${stat.color}20`,
                    width: "60px",
                    height: "60px",
                    background: `${stat.color}1A`,
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: "15px",
                  }}
                >
                  {IconComponent && (
                    <IconComponent size={30} color={stat.color} />
                  )}
                </div>

                <h2
                  className="stat-number"
                  style={{
                    "--stat-text-color-normal": stat.color,
                    "--stat-text-color-hover": `${stat.color}DD`,
                    fontSize: "42px",
                    fontWeight: "800",
                    marginBottom: "8px",
                    lineHeight: "1.1",
                  }}
                >
                  {stat.number}
                </h2>
                <p
                  className="stat-label"
                  style={{
                    color: "#525252",
                    fontSize: "17px",
                    fontWeight: "600",
                    margin: "0",
                    whiteSpace: "pre-line",
                  }}
                >
                  {stat.label}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  TechnicalSupportSection = () => {
    const supportCards = [
      {
        icon: (
          <svg
            width="32"
            height="32"
            viewBox="0 0 24 24"
            fill="none"
            stroke="white"
            strokeWidth="2"
          >
            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
            <polyline points="22,6 12,13 2,6" />
          </svg>
        ),
        title: "Destek",
        description:
          "Detaylı sorularınız için email gönderebilirsiniz. 24 saat içinde yanıtlanır.",
        gradient: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
        shadowColor: "rgba(16, 185, 129, 0.25)",
        email: "Desteğe Ulaşmak İçin Tıkla",
      },
      {
        icon: (
          <svg
            width="32"
            height="32"
            viewBox="0 0 24 24"
            fill="none"
            stroke="white"
            strokeWidth="2"
          >
            <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
            <line x1="8" y1="21" x2="16" y2="21" />
            <line x1="12" y1="17" x2="12" y2="21" />
          </svg>
        ),
        title: "Mobil Uygulama",
        description:
          "Universal Team mobil uygulaması için özel destek. iOS ve Android platformlarında kesintisiz deneyim.",
        gradient: "linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)",
        shadowColor: "rgba(139, 92, 246, 0.25)",
        hasStoreButtons: true,
      },
    ];

    return (
      <div className="row" style={{ marginTop: "50px" }}>
        {supportCards.map((card, index) => (
          <div
            key={index}
            className="col-lg-6 col-md-12 mb-30 d-flex"
            style={{ marginBottom: "30px" }}
          >
            <div
              className="item universal-tech-card universal-shimmer w-100"
              style={{
                background: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
                borderRadius: "16px",
                padding: "35px 25px",
                textAlign: "center",
                boxShadow: "0 15px 40px rgba(0,0,0,0.08)",
                border: "1px solid rgba(226, 232, 240, 0.5)",
                height: "100%",
                minHeight: "350px",
                position: "relative",
                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <div
                className="universal-pattern"
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  background:
                    "linear-gradient(45deg, transparent 30%, rgba(255,255,255,0.1) 50%, transparent 70%)",
                  pointerEvents: "none",
                }}
              ></div>
              <div
                style={{
                  position: "relative",
                  zIndex: 1,
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <div
                    className="tech-icon-container"
                    style={{
                      width: "70px",
                      height: "70px",
                      background: card.gradient,
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "0 auto 25px",
                      boxShadow: `0 8px 25px ${card.shadowColor}`,
                    }}
                  >
                    {card.icon}
                  </div>
                  <h4
                    style={{
                      fontSize: "20px",
                      fontWeight: "600",
                      marginBottom: "15px",
                      color: "#1e293b",
                    }}
                  >
                    {card.title}
                  </h4>

                  {card.email && (
                    <button
                      style={{
                        background:
                          "linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%)",
                        borderRadius: "10px",
                        padding: "12px 15px",
                        marginBottom: "15px",
                        border: "1px solid rgba(34, 197, 94, 0.2)",
                        width: "100%",
                        height: "44px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                      }}
                      className="btn btn-secondary"
                      onClick={() => {
                        window.location.href = "/iletisim";
                      }}
                    >
                      <p
                        style={{
                          color: "#059669",
                          fontWeight: "600",
                          fontSize: "16px",
                          margin: "0",
                        }}
                      >
                        {card.email}
                      </p>
                    </button>
                  )}

                  {card.hasStoreButtons && (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        gap: "10px",
                        width: "100%",
                        marginBottom: "20px",
                      }}
                    >
                      <a
                        className="store-btn"
                        href="https://play.google.com/store/apps/details?id=com.workience.universalteam&utm_source=emea_Med"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          background:
                            "linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)",
                          borderRadius: "8px",
                          padding: "8px 12px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "8px",
                          cursor: "pointer",
                          border: "1px solid rgba(255, 255, 255, 0.1)",
                          minHeight: "40px",
                          flex: 1,
                          textDecoration: "none",
                        }}
                      >
                        <img
                          src="/Assets/Images/googleplay.png"
                          alt="Google Play"
                          style={{
                            width: "20px",
                            height: "20px",
                            borderRadius: "0",
                          }}
                        />
                        <div style={{ textAlign: "left" }}>
                          <div
                            style={{
                              color: "#ffffff",
                              fontSize: "12px",
                              fontWeight: "600",
                              lineHeight: "1.2",
                            }}
                          >
                            Google Play
                          </div>
                        </div>
                      </a>

                      <a
                        className="store-btn"
                        href="https://apps.apple.com/tr/app/nm-universal-team/id6737522734?l=tr"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          background:
                            "linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)",
                          borderRadius: "8px",
                          padding: "8px 12px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "8px",
                          cursor: "pointer",
                          border: "1px solid rgba(255, 255, 255, 0.1)",
                          minHeight: "40px",
                          flex: 1,
                          textDecoration: "none",
                        }}
                      >
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="#ffffff"
                        >
                          <path d="M18.71 19.5C17.88 20.74 17 21.95 15.66 21.97C14.32 22 13.89 21.18 12.37 21.18C10.84 21.18 10.37 21.95 9.1 22C7.79 22.05 6.8 20.68 5.96 19.47C4.25 17 2.94 12.45 4.7 9.39C5.57 7.87 7.13 6.91 8.82 6.88C10.1 6.86 11.32 7.75 12.11 7.75C12.89 7.75 14.37 6.68 15.92 6.84C16.57 6.87 18.39 7.1 19.56 8.82C19.47 8.88 17.39 10.1 17.41 12.63C17.44 15.65 20.06 16.66 20.09 16.67C20.06 16.74 19.67 18.11 18.71 19.5ZM13 3.5C13.73 2.67 14.94 2.04 15.94 2C16.07 3.17 15.6 4.35 14.9 5.19C14.21 6.04 13.07 6.7 11.95 6.61C11.8 5.46 12.36 4.26 13 3.5Z" />
                        </svg>
                        <div style={{ textAlign: "left" }}>
                          <div
                            style={{
                              color: "#ffffff",
                              fontSize: "12px",
                              fontWeight: "600",
                              lineHeight: "1.2",
                            }}
                          >
                            App Store
                          </div>
                        </div>
                      </a>
                    </div>
                  )}
                </div>

                <p
                  style={{
                    color: "#64748b",
                    lineHeight: "1.6",
                    marginBottom: "0",
                    fontSize: "14px",
                    marginTop: "15px",
                  }}
                >
                  {card.description}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  };

  handlePhoneChange = (e) => {
    const input = e.target.value;
    const digitsOnly = input.replace(/\D/g, "");
    const truncated = digitsOnly.substring(0, 10);

    let formatted = "";
    if (truncated.length > 0) {
      formatted = truncated.replace(
        /(\d{3})(\d{0,3})(\d{0,2})(\d{0,2})/,
        (_, p1, p2, p3, p4) => {
          let result = p1;
          if (p2) result += " " + p2;
          if (p3) result += " " + p3;
          if (p4) result += " " + p4;
          return result;
        }
      );
    }

    this.setState({ phone: formatted });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const phoneDigits = this.state.phone.replace(/\D/g, "");
    if (phoneDigits.length !== 10) {
      alert("Lütfen geçerli bir telefon numarası giriniz (5XX XXX XX XX)");
      return;
    }
  };

  render() {
    return (
      <>
        <div style={{ background: "#f8fafc", minHeight: "100vh" }}>
          <Loader />
          <SubHeader />
          <Header
            isLoggedIn={Boolean(Cookies.get("token") || localStorage.getItem("token"))}
            userName="Mehmet Özkan"
          />
          <DarkVeilHeroBanner />

          <div
            className="video-content"
            style={{
              padding: "80px 0",
              background: "#f8f9fafc",
            }}
          >
            <div className="container">
              <div className="row">
                <div className="col-lg-8 col-md-10 offset-lg-2 offset-md-1">
                  <div
                    className="section-heading text-center"
                    style={{ marginBottom: "60px" }}
                  >
                    <h6
                      style={{
                        color: "#64748b",
                        fontSize: "14px",
                        fontWeight: "600",
                        letterSpacing: "1px",
                        textTransform: "uppercase",
                        marginBottom: "15px",
                      }}
                    >
                      📺 TANITIM VİDEOMUZ
                    </h6>
                    <h2
                      style={{
                        color: "#1e293b",
                        fontSize: "36px",
                        fontWeight: "700",
                        marginBottom: "20px",
                        lineHeight: "1.2",
                      }}
                    >
                      Universal Team Hikayemizi Keşfedin
                    </h2>
                    <p
                      style={{
                        color: "#64748b",
                        fontSize: "18px",
                        lineHeight: "1.6",
                        maxWidth: "600px",
                        margin: "0 auto",
                      }}
                    >
                      Başarı hikayelerimizi, değerlerimizi ve vizyonumuzu bu
                      özel videomuzda keşfedin. Universal Team ailesinin
                      büyüleyici yolculuğuna tanık olun.
                    </p>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-lg-10 offset-lg-1">
                  <div
                    className="video-player-container"
                    style={{
                      position: "relative",
                      borderRadius: "20px",
                      overflow: "hidden",
                      boxShadow: "0 30px 60px rgba(0,0,0,0.3)",
                      background: "#000",
                      border: "4px solid rgba(255,255,255,0.1)",
                    }}
                  >
                    <div
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background:
                          "linear-gradient(45deg, transparent 30%, rgba(255,255,255,0.03) 50%, transparent 70%)",
                        pointerEvents: "none",
                        zIndex: 1,
                      }}
                    ></div>

                    <div style={{ position: "relative", zIndex: 2 }}>
                      <UniversalVideoPlayer videoUrl="https://www.loom.com/share/f1c8f124c0ec47f58d09285b17871258" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className="properties section"
            style={{ background: "#FFFFFF", padding: "80px 0" }}
          >
            <div className="container">
              <div className="row">
                <div className="col-lg-8 col-md-10 offset-lg-2 offset-md-1">
                  <div className="section-heading text-center">
                    <h6
                      style={{
                        color: "#64748b",
                        fontWeight: "600",
                        textTransform: "uppercase",
                        letterSpacing: "1px",
                      }}
                    >
                      BAŞARIYA GİDEN YOL
                    </h6>
                    <h2
                      style={{
                        color: "#1e293b",
                        fontWeight: "700",
                        fontSize: "36px",
                        lineHeight: "1.2",
                      }}
                    >
                      Universal Team ile başarıya ulaşmak için ihtiyacın olan
                      her şey burada
                    </h2>
                  </div>
                </div>
              </div>
              <this.MainSections />
            </div>
          </div>

          <section
            className="philosophy-section"
            style={{ padding: "100px 0", background: "#f8f9fafc" }}
          >
            <div className="container">
              <div
                className="row justify-content-center text-center"
                style={{ marginBottom: "60px" }}
              >
                <div className="col-lg-8 col-md-10">
                  <h2
                    style={{
                      fontSize: "38px",
                      fontWeight: "bold",
                      marginBottom: "15px",
                      color: "#1a202c",
                    }}
                  >
                    Universal Team Felsefesi
                  </h2>
                  <p style={{ fontSize: "18px", color: "#4a5568" }}>
                    Başarıya giden yolda sizi motive eden üç temel adım: Hayal
                    Et, İnan, Başla!
                  </p>
                </div>
              </div>
              {this.PhilosophyCards()}{" "}
            </div>
          </section>

          <section
            className="statistics-section"
            style={{ padding: "100px 0", background: "#ffffff" }}
          >
            <div className="container">
              <div
                className="row justify-content-center text-center"
                style={{ marginBottom: "60px" }}
              >
                <div className="col-lg-8 col-md-10">
                  <h6
                    style={{
                      color: "#64748b",
                      fontWeight: "600",
                      textTransform: "uppercase",
                      letterSpacing: "1px",
                    }}
                  >
                    BAŞARI İSTATİSTİKLERİMİZ
                  </h6>
                  <h2
                    style={{
                      fontSize: "38px",
                      fontWeight: "bold",
                      marginBottom: "15px",
                      color: "#1a202c",
                    }}
                  >
                    Rakamlarla Universal Team Başarısı
                  </h2>
                  <p style={{ fontSize: "18px", color: "#4a5568" }}>
                    Büyüyen ailemiz ve başarı hikayelerimizle gurur duyuyoruz.
                  </p>
                </div>
              </div>
              {this.StatisticsSection()}
            </div>
          </section>

          <div
            className="properties section"
            style={{ background: "transparent", padding: "80px 0" }}
          >
            <div className="container">
              <div className="row">
                <div className="col-lg-8 col-md-10 offset-lg-2 offset-md-1">
                  <div className="section-heading text-center">
                    <h6
                      style={{
                        color: "#64748b",
                        fontWeight: "600",
                        textTransform: "uppercase",
                        letterSpacing: "1px",
                      }}
                    >
                      TEKNİK DESTEK
                    </h6>
                    <h2
                      style={{
                        color: "#1e293b",
                        fontWeight: "700",
                        fontSize: "36px",
                        lineHeight: "1.2",
                      }}
                    >
                      Profesyonel Teknik Destek Hizmetimiz
                    </h2>
                    <p
                      style={{
                        color: "#64748b",
                        marginTop: "15px",
                        fontSize: "16px",
                      }}
                    >
                      Web platformu ve Universal Team mobil uygulaması için
                      güvenilir ve hızlı teknik destek hizmeti sunuyoruz.
                    </p>
                  </div>
                </div>
              </div>

              <this.TechnicalSupportSection />

              <div className="row">
                <div className="col-lg-12">
                  <div
                    className="item universal-info-card universal-shimmer"
                    style={{
                      background:
                        "linear-gradient(135deg, #ffffff 0%, #f1f5f9 100%)",
                      border: "1px solid rgba(226, 232, 240, 0.6)",
                      borderRadius: "16px",
                      padding: "35px",
                      textAlign: "center",
                      boxShadow: "0 10px 30px rgba(0,0,0,0.06)",
                      position: "relative",
                      overflow: "hidden",
                    }}
                  >
                    <div
                      className="universal-pattern"
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background:
                          "linear-gradient(45deg, transparent 40%, rgba(255,255,255,0.1) 50%, transparent 60%)",
                        pointerEvents: "none",
                      }}
                    ></div>
                    <div style={{ position: "relative", zIndex: 1 }}>
                      <h5
                        style={{
                          color: "#374151",
                          fontWeight: "600",
                          fontSize: "18px",
                        }}
                      >
                        💡 Hızlı Çözüm Garantisi
                      </h5>
                      <p
                        style={{
                          margin: "0",
                          fontSize: "15px",
                          lineHeight: "1.6",
                          color: "#64748b",
                        }}
                      >
                        Profesyonel teknik ekibimiz, web platformu ve mobil
                        uygulama sorunlarınızı en kısa sürede çözmek için 7/24
                        hizmetinizdedir. Modern teknolojiler ve deneyimli
                        uzmanlarımızla kesintisiz bir deneyim yaşayın.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Footer />
        </div>

        <script src="vendor/jquery/jquery.min.js"></script>
        <script src="vendor/bootstrap/js/bootstrap.min.js"></script>
        <script src="assets/js/isotope.min.js"></script>
        <script src="assets/js/owl-carousel.js"></script>
        <script src="assets/js/counter.js"></script>
        <script src="assets/js/custom.js"></script>
      </>
    );
  }
}
